import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchAreas = () => api.get("/areas-of-focus").then((r) => r.data);
export const fetchInitiatives = () => api.get("/initiatives").then((r) => r.data);
export const fetchInitiative = (slug) => api.get(`/initiatives/${slug}`).then((r) => r.data);
export const fetchPartners = () => api.get("/partner-types").then((r) => r.data);
export const fetchResources = (params = {}) =>
  api.get("/resources", { params }).then((r) => r.data);
export const fetchFacets = () => api.get("/resources/facets").then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
